module.exports = __webpack_public_path__ + "img/Vip_Card_5.32b07aa0.png";